import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { api, POST, POST_JSON } from "../../ConsumeApiController";

export async function createPromotion(
    merchant_id,
    title, modality, discount_type, discount_value, 
    global_stock, usage_limit_per_user, valid_from, valid_until, status='active')
{
    const response = await api.post(CompanyRoutes.Loyalty.Create,{
        merchant_id,
        title,
        modality, 
        discount_type, 
        discount_value, 
        global_stock, 
        usage_limit_per_user, 
        valid_from, 
        valid_until,
        status
    });
    return response;
}

export async function getPromotions() {
    try {
        const response = await api.get(CompanyRoutes.Loyalty.GetAll);

        if (response.success) {
            // Desestructuramos y retornamos directamente
            const { promotions, stats } = response.data;
            return { promotions, stats };
        }

        // Si la API responde con success: false (ej. validación fallida),
        // devolvemos valores por defecto seguros (stats es un objeto, no un array).
        return { promotions: [], stats: {} };

    } catch (error) {
        // Si hay un error de red o el servidor devuelve un 500
        console.error("Error al obtener promociones y estadísticas:", error);
        
        // Retornamos la misma estructura vacía para que la UI no se rompa
        return { promotions: [], stats: {} };
    }
}

export async function getPromotionDetail(promotionId) {
    try {
        const response = await api.get(CompanyRoutes.Loyalty.GetDetail(promotionId));

        if (response.success) {
            // Desestructuramos y retornamos directamente
            const { promotion, recent_activity } = response.data;
            return { promotion, recent_activity };
        }

        // Si la API responde con success: false (ej. validación fallida),
        // devolvemos valores por defecto seguros (stats es un objeto, no un array).
        return { promotions: {}, recent_activity: [] };

    } catch (error) {
        // Si hay un error de red o el servidor devuelve un 500
        console.error("Error al obtener los detalles de la promoción:", error);
        
        // Retornamos la misma estructura vacía para que la UI no se rompa
        return { promotions: {}, recent_activity: [] };
    }
}

export async function getPromotionsStats()
{
    const response = await api.get(CompanyRoutes.Loyalty.GetStats);
    const {revenue, total_redemptions, qud_pass_clients, active_promos} = response.data;
    return {revenue, total_redemptions, qud_pass_clients, active_promos};

}

export async function togglePromotionStatus(promotionId,newStatus)
{
    const response = await api.post(CompanyRoutes.Loyalty.TOGGLE_STATUS(promotionId),{ status: newStatus })
    return response;
}

